import { useState } from 'react';
import { getCookie, setCookie } from '../utils/cookies';

export default function useCookieState<T>(key: string, defaultValue: T, daysToExpire = 21) {
  const [state, setState] = useState<T>(() => {
    const cookieValue = getCookie(key);
    const parsedValue = cookieValue ? (JSON.parse(cookieValue) as T) : defaultValue;

    // refresh cookie expiry upon initial access
    setCookie(key, JSON.stringify(parsedValue), daysToExpire);
    return parsedValue;
  });

  const setCookieState = (newValue: T) => {
    setState(newValue);
    setCookie(key, JSON.stringify(newValue), daysToExpire);
  };

  return [state, setCookieState] as const;
}
